import { StepStatus } from '@/models/step.model';
import { COLORS, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Link, Tag } from '@/ui';
import styled, { css } from 'styled-components';
import { StepProgressStatus } from '../../helpers';
import { SigningStatus } from '@/models/contract.model';

const getStatusStyles = (status?: StepStatus | StepProgressStatus) => {
  switch (status) {
    case StepStatus.NEW:
    case StepProgressStatus.NEW:
    case StepProgressStatus.PENDING:
      return css`
        background-color: ${pickThemeColor('GRAY_STATUS')}1A;
        color: ${pickThemeColor('GRAY_STATUS')};
      `;
    case StepStatus.IN_PROGRESS:
    case StepProgressStatus.WAITING:
      return css`
        background-color: ${pickThemeColor('YELLOW')};
        color: ${pickThemeColor('WHITE')};
      `;
    case StepStatus.COMPLETED:
      return css`
        background-color: ${pickThemeColor('GREEN')}1A;
        color: ${pickThemeColor('GREEN')};
      `;
    case StepStatus.CANCELED:
      return css`
        background-color: ${pickThemeColor('RED_CORAL')}1A;
        color: ${pickThemeColor('RED_CORAL')};
      `;
    default:
      return css``;
  }
};

const getSigningStatusStyles = (status?: SigningStatus) => {
  switch (status) {
    case SigningStatus.PENDING:
      return css`
        background-color: ${pickThemeColor('PEACH_LIGHT')};
        color: ${pickThemeColor('PEACH')};
      `;
    case SigningStatus.SIGNED:
      return css`
        background-color: ${pickThemeColor('GREEN')}1A;
        color: ${pickThemeColor('GREEN')};
      `;
    case SigningStatus.REJECTED:
    case SigningStatus.EXPIRED:
      return css`
        background-color: ${pickThemeColor('RED_CORAL')}1A;
        color: ${pickThemeColor('RED_CORAL')};
      `;
    default:
      return css``;
  }
};

export const StyledTag = styled(Tag)<{
  $status?: StepStatus | StepProgressStatus;
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  border: none;
  width: fit-content;
  text-transform: capitalize;
  margin: 0;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${(props) => getStatusStyles(props.$status)}
`;

export const StyledContractTag = styled(Tag)<{
  $status?: SigningStatus;
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  border: none;
  width: fit-content;
  text-transform: capitalize;
  margin: 0;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${(props) => getSigningStatusStyles(props.$status)}
`;

export const StyledLink = styled(Link)`
  ${pickThemeFontStyles('16', '20')};
  text-transform: capitalize;
  color: ${pickThemeColor('ORANGE_PRIMARY')};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    color: ${pickThemeColor('ORANGE_PRIMARY')};
  }
`;

export const StyledLabel = styled.span`
  ${pickThemeFontStyles('14', '20')};
  color: ${pickThemeColor('GREY')};
`;

export const StyledText = styled.p`
  ${pickThemeFontStyles('16', '26')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
  margin: 0;
  display: flex;
  gap: 0.25rem;

  a {
    ${pickThemeFontStyles('16', '20')};
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    word-break: break-all;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      color: ${pickThemeColor('ORANGE_PRIMARY')};
    }
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
`;

export const StyledListRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledTime = styled.div`
  color: ${pickThemeColor('DARK_GREEN')};
  ${pickThemeFontStyles('14', '20')};

  span {
    color: ${pickThemeColor('GREY')};
  }
`;

export const StyledButtonsWrap = styled.div<{ type?: string }>`
  display: flex;
  gap: 1rem;

  path {
    fill: ${({ type = 'primary' }) => type === 'primary' && COLORS.WHITE};
  }

  &:hover {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;
